<template>
  <div class="about">
    <v-container class="constrain">
      <div>
        <v-row class="pb-5">
          <v-col cols="12">
            <h2 class="white--text">Fights</h2>
          </v-col>
        </v-row>
        <v-data-table
            dark
            :headers="headers"
            :items="fightsdata"
            :sort-by.sync="sortBy"
            color="none"
            :search="search"
            class="tabless text-center"
            :loading="loading"
          >
            <template v-slot:top>
              <v-toolbar
                class="tabletoolbar"
                flat
              >
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog
                  v-model="dialog"
                  max-width="750px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="red"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      New Fight
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>
                      <v-form 
                        ref="form"
                        v-model="valid"
                      >
                    <v-card-text>

                      
                      <v-container>
                        <v-row v-if="newuser === true" class="text-center">
                        
                            <v-col cols="12" sm="4" md="4">
                                <h2>
                                    {{ editedItem.Fighter1Name }} 
                                    {{ editedItem.Fighter1SurName }}
                                </h2>
                                <v-avatar class="my-3" size="107">
                                    <img
                                        :src="editedItem.Fighter1Image"
                                        alt="John" 
                                    >
                                </v-avatar>
                                <h2>{{ editedItem.Fighter1Percentage }} %</h2>
                                <v-row>
                                  <v-col class="col-4 text-center px-1">
                                    <div class="text-center Wins white--text py-2 records">
                                      <h2>{{editedItem.Fighter1Wins}}</h2>
                                    </div>
                                    <div class="text-center WinsKO mt-2">
                                      {{editedItem.Fighter1Wins_by_KO}} BY KO
                                    </div>
                                  </v-col>
                                  <v-col class="col-4 px-1">
                                    <div class="text-center Losses white--text py-2 records">
                                      <h2>{{editedItem.Fighter1Losses}}</h2>
                                    </div>
                                    <div class="text-center LossesKO mt-2">
                                      {{editedItem.Fighter1Losses_by_KO}} BY KO
                                    </div>
                                  </v-col>
                                  <v-col class="col-4 text-center px-1">
                                    <div class="Draws white--text py-2 records">
                                      <h2>{{editedItem.Fighter1Draws}}</h2>
                                    </div>
                                  </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <p class="mb-0">{{editedItem.DateStart}}</p>
                                <p>{{editedItem.TimeStart}}</p>
                                <h1>vs</h1>
                                <h2 class="my-3">{{editedItem.Weightdivision}} Weight Division</h2>
                                <h2 class="my-3">{{editedItem.Rounds}} Rounds</h2>
                                <!-- <p>Voting closes</p> -->
                                <p class="mb-0">Voting closes <br>
                                  {{editedItem.DateEnd}}</p>
                                  <p>{{editedItem.TimeEnd}}</p>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <h2>
                                    {{ editedItem.Fighter2Name }} 
                                    {{ editedItem.Fighter2SurName }}
                                </h2>
                                <v-avatar class="my-3" size="107">
                                    <img
                                        :src="editedItem.Fighter2Image"
                                        alt="John"
                                    >
                                </v-avatar>
                                <h2>{{ editedItem.Fighter2Percentage }} %</h2>
                                <v-row>
                                  <v-col class="col-4 text-center px-1">
                                    <div class="text-center Wins white--text py-2 records">
                                      <h2>{{editedItem.Fighter2Wins}}</h2>
                                    </div>
                                    <div class="text-center WinsKO mt-2">
                                      {{editedItem.Fighter2Wins_by_KO}} BY KO
                                    </div>
                                  </v-col>
                                  <v-col class="col-4 px-1">
                                    <div class="text-center Losses white--text py-2 records">
                                      <h2>{{editedItem.Fighter2Losses}}</h2>
                                    </div>
                                    <div class="text-center LossesKO mt-2">
                                      {{editedItem.Fighter2Losses_by_KO}} BY KO
                                    </div>
                                  </v-col>
                                  <v-col class="col-4 text-center px-1">
                                    <div class="Draws white--text py-2 records">
                                      <h2>{{editedItem.Fighter2Draws}}</h2>
                                    </div>
                                  </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            v-if="newuser === false"
                            cols="12"
                            sm="12"
                            md="6"
                          >
                           <v-select
                                v-model="editedItem.Fighter_1"
                                :items="selectorNames"
                                :rules="[rules.required]"
                                item-text="name"
                                item-value="id"
                                label="Choose Fighter 1"
                            ></v-select>
                          </v-col>
                          <v-col
                          v-if="newuser === false"
                            cols="12"
                            sm="12"
                            md="6"
                          >
                          <v-select
                                v-model="editedItem.Fighter_2"
                                :items="selectorNames"
                                :rules="[rules.required]"
                                item-text="name"
                                item-value="id"
                                label="Choose Fighter 2"
                            >
                            
                            </v-select>
                            <!-- <v-text-field
                              :rules="[rules.required]"
                              v-model="editedItem.Surname"
                              label="Fighter Surname"
                            ></v-text-field> -->
                          </v-col>
                          <v-col
                          v-if="newuser === false"
                            cols="12"
                            sm="12"
                            md="6"
                          >
                          <v-select
                            v-model="editedItem.Rounds"
                            :items="rounds"
                            :rules="[rules.required]"
                            item-text="text"
                            item-value="value"
                            label="Select Rounds"
                          ></v-select>

                          </v-col>
                          <v-col
                          v-if="newuser === false"
                            cols="12"
                            sm="12"
                            md="6"
                          >
                          <v-select
                            v-model="editedItem.Weightdivision"
                            :items="weightdivisions"
                            :rules="[rules.required]"
                            item-text="text"
                            item-value="value"
                            label="Weight Division"
                          ></v-select>

                          </v-col>


                          <!-- Start Date -->
                          <v-col
                            cols="12"
                            sm="6"
                            md="6"
                            v-if="newuser === false"
                          >
                            <v-menu
                              ref="startdate"
                              v-model="startdate"
                              :close-on-content-click="false"
                              :return-value.sync="editedItem.DateStart"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="editedItem.DateStart"
                                  label="Pick Start Date"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="editedItem.DateStart"
                                no-title
                                scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="startdate = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="$refs.startdate.save(editedItem.DateStart)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col
                            cols="6"
                            sm="6"
                            v-if="newuser === false"
                          >
                            <v-menu
                              ref="starttime"
                              v-model="starttime"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="editedItem.TimeStart"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="editedItem.TimeStart"
                                  label="Pick Start Time"
                                  prepend-icon="mdi-clock-time-four-outline"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-time-picker
                                v-if="starttime"
                                v-model="editedItem.TimeStart"
                                full-width
                                @click:minute="$refs.starttime.save(editedItem.TimeStart)"
                              ></v-time-picker>
                            </v-menu>
                          </v-col>




                          <v-col
                            cols="12"
                            sm="6"
                            md="6"
                            v-if="newuser === false"
                          >
                            <v-menu
                              ref="enddate"
                              v-model="enddate"
                              :close-on-content-click="false"
                              :return-value.sync="editedItem.DateEnd"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="editedItem.DateEnd"
                                  label="Pick End Date"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="editedItem.DateEnd"
                                no-title
                                scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="enddate = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="$refs.enddate.save(editedItem.DateEnd)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>


                          <v-col
                            cols="6"
                            sm="6"
                            v-if="newuser === false"
                          >
                            <v-menu
                              ref="endtime"
                              v-model="endtime"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="editedItem.TimeEnd"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="editedItem.TimeEnd"
                                  label="Pick End Time"
                                  prepend-icon="mdi-clock-time-four-outline"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-time-picker
                                v-if="endtime"
                                v-model="editedItem.TimeEnd"
                                full-width
                                @click:minute="$refs.endtime.save(editedItem.TimeEnd)"
                              ></v-time-picker>
                            </v-menu>
                          </v-col>
                          <v-col
                          cols="12"
                            sm="12"
                            v-if="newuser === false"
                          >
                          <v-text-field
                            v-model="editedItem.FightTitle"
                            label="Fight Title"
                            :rules="[rules.required]"
                          ></v-text-field>
                          <!-- <v-textarea
                          v-model="editedItem.Story"
                          :rules="[rules.required]"
                            clearable
                            clear-icon="mdi-close-circle"
                            label="Story"
                          ></v-textarea> -->
                          </v-col>
                          <v-col
                          cols="12"
                            sm="12"
                            v-if="newuser === false"
                          >
                          <!-- <v-text-field
                          v-model="editedItem.Story"
                            label="Story"
                          :rules="[rules.required]"
                          ></v-text-field> -->
                          <v-textarea
                          v-model="editedItem.Story"
                            clearable
                            clear-icon="mdi-close-circle"
                            label="Story (Optional)"
                          ></v-textarea>
                          </v-col>
                        </v-row>
                      </v-container>

                  

                    
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="red darken-1"
                        text
                        @click="close"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        v-model="newuser"
                        v-if="newuser === false"
                        color="red darken-1"
                        text
                        @click="addfight"
                        :disabled="!valid"
                      >
                        Save
                      </v-btn>
                      
                    </v-card-actions>
                    </v-form>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:[`item.Image`]="{ item }">
              <v-list-item-avatar>
                    <v-img
                      :src="item.Image"
                    ></v-img>
                  </v-list-item-avatar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
              >
                mdi-eye
              </v-icon>
              <v-icon
                small
                @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
      </div>
      </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment';
// import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import db from '../firebaseConfig'
import { collection, getDocs, addDoc, updateDoc, doc, setDoc, deleteDoc, getDoc, query, where } from "firebase/firestore";
export default {
    data: () => ({

      startdate: false,
      starttime: false,
      enddate: false,
      endtime: false,

      // time: '',
      menu2: false,

      Name:'',
      loading: false,
      newuser: false,
      name:'',
      id:'',
      timeProps: {
        useSeconds: true,
        ampmInTitle: true
      },
      valid:false,
      search: '',
      dialog: false,
      dialogDelete: false,
      files: [],
      heyyyyy: [],
      
      sortBy: 'DateStart',
      sortDesc: false,
      headers: [
        // { text: 'Id', value: 'index' },
        {
          text: 'Fighter 1 Name',
          align: 'center',
          sortable: false,
          value: 'Fighter1Name',
        },
         { text: 'Fighter 1 Surname', value: 'Fighter1SurName', align: 'center', sortable: false },
         { text: 'Fighter 2 Name', value: 'Fighter2Name', align: 'center', sortable: false },
         { text: 'Fighter 2 Surname', value: 'Fighter2SurName', align: 'center', sortable: false },
        // { text: 'Fighter 2', value: 'Fighter_2', align: 'center', sortable: false },
        { text: 'Rounds', value: 'Rounds', align: 'center', sortable: false },
        { text: 'Date Added', value: 'DateAdded', align: 'center' },
        { text: 'DateStart', value: 'DateStart', align: 'center', sortable: false },
        { text: 'DateEnd', value: 'DateEnd', align: 'center', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      rounds:[
          {text: '10 Rounds', value:'10'},
          {text: '12 Rounds', value:'12'},
          {text: '15 Rounds', value:'15'}
      ],
      editedIndex: -1,
      editedItem: {
        Fighter_1:'',
        Fighter_2:'',
        Rounds: '',
        Weightdivision:'',
        Votes: 0,
        FightTitle:'',
        Story:'',
        DateStart: '',
        TimeStart:'',
        DateEnd: '',
        TimeEnd:'',
      },
      defaultItem: {
        Fighter_1:'',
        Fighter_2:'',
        Rounds: '',
        Weightdivision:'',
        Votes: 0,
        FightTitle:'',
        Story:'',
        DateStart: '',
        TimeStart:'',
        DateEnd: '',
        TimeEnd:'',
      },
       firstfightersname:'',
       secondfightersname:'',
       myfirstfighterdatas: [],
       mysecondfighterdatas :[],
      rules: {
          required: value => !!value || 'Required.',
      },
      weightdivisions: [
        {text: 'Minimumweight', value:'minimumweight'},
        {text: 'Light Flyweight', value:'light_flyweight'},
        {text: 'Flyweight', value:'flyweight'},
        {text: 'Super Flyweight', value:'super_flyweight'},
        {text: 'Bantamweight', value:'bantamweight'},
        {text: 'Super Bantamweight', value:'super_bantamweight'},
        {text: 'Featherweight', value:'featherweight'},
        {text: 'Super Featherweight', value:'super_featherweight'},
        {text: 'Lightweight', value:'lightweight'},
        {text: 'Super Lightweight', value:'super_lightweight'},
        {text: 'Welterweight', value:'welterweight'},
        {text: 'Super Welterweight', value:'super_welterweight'},
        {text: 'Middleweight', value:'middleweight'},
        {text: 'Super Middleweight', value:'super_middleweight'},
        {text: 'Light Heavyweight', value:'light_heavyweight'},
        {text: 'Cruiserweight', value:'Cruiserweight'},
        {text: 'Heavyweight', value:'heavyweight'},
        {text: 'Multiple', value:'multiple'},
        
      ],

    }),
    created() {
      this.setShow()
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Fight' : 'Fight Details'
      },
      ...mapGetters([
        'fighters',
        'fights',
        // 'fightsdata',
        'fightsdata',
        'selectorNames'
      ]),
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    methods: {
      setShow() {
        this.loading = true
        setTimeout(() => {
            this.loading = false
        }, 2000);
      },
    async addfight(){
      try{
        const newFightRef = doc(collection(db, "fights"));
        let myid = newFightRef
        // console.log('newCityRef', newFighterRef)
        this.loading = true
        let date = new Date();
        console.log('this.editedItem.Story',this.editedItem.Story)
        const data = {
            uid: myid.id,
            Fighter_1: this.editedItem.Fighter_1,
            Fighter_2: this.editedItem.Fighter_2,
            Rounds: this.editedItem.Rounds,
            Weightdivision:this.editedItem.Weightdivision,
            FightTitle:this.editedItem.FightTitle,
            Story: this.editedItem.Story,
            Votes: this.editedItem.Votes,
            DateStart: moment(this.editedItem.DateStart).format("dddd, MMMM Do YYYY"),
            TimeStart: this.editedItem.TimeStart,
            DateEnd: moment(this.editedItem.DateEnd).format("dddd, MMMM Do YYYY"),
            TimeEnd: this.editedItem.TimeEnd,
            DateAdded: moment().toISOString(),

            Winner: "",
            WinBy:"",
            // Story:"",
            KoRoundVote:"",
            DecisionRoundVote:"",
            VoteCount:"",        
            
            }

            console.log('data', data)

        await setDoc(newFightRef, data)
        console.log("Document written with ID: ", newFightRef.id);
        this.loading = false
        this.save()
        // this.name = ''
        this.editedItem.DateStart =  ''
        this.editedItem.DateEnd = ''
      }catch(e){
        this.failed = true
        console.error("Error adding document: ", e);
      }

    },
    validate () {
        this.$refs.form.validate()
    },
    async editItem(item) {
  

        this.newuser = true
        this.editedIndex = this.fightsdata.indexOf(item)
        //console.log('this.editedIndex', this.editedIndex)
        this.editedItem = Object.assign({}, item)
        //console.log('this.editedItem', this.editedItem)

      //   let uid = this.editedItem
      //   //console.log('editedItem uid', uid)

      //   console.log('uid.Fighter_1', uid.Fighter_1)

      //   const q = query(collection(db, "fighters"), where("Name", "==", uid.Fighter_1));
      //   const q2 = query(collection(db, "fighters"), where("Name", "==", uid.Fighter_2));
      //  // console.log('q', q)
      //   //console.log('q2', q2)


      //   const querySnapshot = await getDocs(q);
      //   querySnapshot.forEach((doc) => {
      //       let myfirstfighterdata = doc.data()
      //       // let firstname = myfirstfighterdata[0].Name
      //       this.myfirstfighterdatas.push(myfirstfighterdata)

      //   // doc.data() is never undefined for query doc snapshots
      //   console.log('myfirstfighter', myfirstfighterdata);
      //   });



      //   const querySnapshot2 = await getDocs(q2);
      //   querySnapshot2.forEach((doc) => {
      //       let mysecondfighterdata = doc.data()
      //       this.mysecondfighterdatas.push(mysecondfighterdata)

      //   // doc.data() is never undefined for query doc snapshots
      //   console.log('mysecondfighterdata', mysecondfighterdata);
      //   });


      //   console.log('uid',uid)
        this.dialog = true
    },
    async updatefighterinfo() {
    let uid = this.editedItem.id
    let date = new Date()
    const fighterRef = doc(db, "fights", uid);
        console.log(fighterRef)
        await updateDoc(fighterRef, {
            Fighter_1: this.editedItem.Fighter_1,
            Fighter_2: this.editedItem.Fighter_2,
            Rounds: this.editedItem.Rounds,
            Weightdivision:this.editedItem.Weightdivision,
            FightTitle:this.editedItem.FightTitle,
            Story: this.editedItem.Story,
            Votes: this.editedItem.Votes,
            DateStart: moment(this.editedItem.DateStart).format("dddd, MMMM Do YYYY"),
            TimeStart: this.editedItem.TimeStart,
            DateEnd: moment(this.editedItem.DateEnd).format("dddd, MMMM Do YYYY"),
            TimeEnd: this.editedItem.TimeEnd,
            DateAdded: moment(date).format("dddd, MMMM Do YYYY")
        });
        this.save()
    },
    deleteItem(item) {
        this.editedIndex = this.fightsdata.indexOf(item)
        this.editedItem = Object.assign({}, item)
        // console.log('this.editedItem.uid', this.editedItem.uid)
        // this.deleteFighter(this.editedItem.uid)
        this.dialogDelete = true
    },
    deleteItemConfirm () {
        this.fightsdata.splice(this.editedIndex, 1)
        this.deleteFighter(this.editedItem.Fightuid)
        this.closeDelete()
    },
     async deleteFighter(item) {
        // console.log('delete user', item)
        await deleteDoc(doc(db, "fights", item))
    },
    close() {
          this.dialog = false
          this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
        // console.log('fuck', this.editedItem.DateStart)
        this.$refs.form.reset()
        this.newuser = false
        this.myfirstfighterdatas = []
        this.mysecondfighterdatas = []
    },
    closeDelete () {
        this.dialogDelete = false
        this.setShow()
        // this.getfights()
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
    },
    save() {
      // this.loading = true
        if (this.editedIndex > -1) {
          Object.assign(this.fightsdata[this.editedIndex], this.editedItem)
        } else {

          this.$store.dispatch('setgetfightsjoin')

        }
        this.$refs.form.reset()
        // this.loading = false
        this.close()
    },
    },
  }
</script>

<style lang="sass">
.v-toolbar__content
  background: transparent


// .tabless tr td
//   text-align: center !important

// .constrain 
//     max-width: 975px
//     margin: 0 auto

</style>
